// Batches and jobs share one status vocabulary, matching the backend PredictionBatchStatus and
// PredictionJobStatus enums.
export type PredictionBatchStatus = 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED';

export function isTerminalStatus(status: PredictionBatchStatus): boolean {
  return status === 'COMPLETED' || status === 'FAILED';
}

export type SortField = 'createdAt' | 'modifiedAt' | 'name';
export type SortDirection = 'asc' | 'desc';

export interface SortConfig {
  key: SortField;
  direction: SortDirection;
}

export interface PredictionBatchRow {
  id: string;
  name: string;
  status: PredictionBatchStatus;
  modelName: string;
  creatorName: string;
  createdAt: string;
  modifiedAt: string;
  folderId: string | null;
  folderName: string;
  numPredictionJobs: number | null;
}
